<div class="contenitore">
  <div class="titolo-pagina">
    <app-titolo-subtitolo
      titolo="Aziende"
      subTitolo="Crea o modifica le anagrafiche delle aziende. Gestisci e assegna gli utenti ad aziende specifiche."
    ></app-titolo-subtitolo>
  </div>
  <app-lista-aziende></app-lista-aziende>
</div>
